import React from "react";
import type { CommandViewResponse } from "../../lib/floorStackApi.js";

interface Props {
  data: CommandViewResponse;
  visible: boolean;
}

const SEVERITY_FILL: Record<string, string> = {
  info: "#9b9ba1",
  low: "#ffb800",
  med: "#ff9100",
  high: "#ff5b6d",
  critical: "#ff2d4a",
};

export default function IncidentLayer({ data, visible }: Props): React.ReactElement | null {
  if (!visible) return null;
  const incidents = data.active_incidents ?? [];
  if (incidents.length === 0) return null;
  return (
    <g data-layer="incidents" pointerEvents="none">
      {incidents.map((inc) => {
        if (inc.position_x == null || inc.position_y == null) return null;
        const colour = SEVERITY_FILL[inc.severity] ?? "#ff5b6d";
        return (
          <g key={inc.id} transform={`translate(${inc.position_x}, ${inc.position_y})`}>
            <circle r={14} fill={colour} fillOpacity={0.18} stroke={colour} strokeWidth={2} />
            <text x={0} y={4} fontSize={11} fontWeight={700} textAnchor="middle" fill={colour}>!</text>
          </g>
        );
      })}
    </g>
  );
}
